import React from 'react';
import "./NextBtn.css";

const NextBtn = ({value, icon, bgColor, color, bold, centerSpacing, leftIcon, nextClick=()=>{}, padx=16, pady=12, disabled, textCenter, btnFullWidth=false, opacity=1, showIcon=true}) => {
  return (
    <div className={`nextBtn text-[${color}] ${bold ? 'font-bold' : ''} ${textCenter ? 'justify-center' : ''} ${centerSpacing ? 'justify-between' : ''} ${disabled ? 'pointer-events-none' : ''} ${btnFullWidth ? 'w-full' : ''}`} style={{padding: `${pady}px ${padx}px`, opacity: opacity, backgroundColor: bgColor}} onClick={nextClick}>
        {leftIcon && showIcon && <img className={`${centerSpacing ? 'pr-2': ''}`} src={icon} alt={value}/>}
        <div>{value}</div>
        {!leftIcon && showIcon && <img className={`${centerSpacing ? 'pl-2': ''}`} src={icon} alt={value}/>}
    </div>
  )
}

export default NextBtn